module.exports = __webpack_public_path__ + "static/media/Emotional.48112c0e.jpg";